export default __webpack_public_path__ + "1511257fc921b33da605ae100d1adb94.svg";